/* The number of columns in the grid at each breakpoint is *not* customisable by theme. Instead,
these are constants intrinsic to the library.

Use these whenever you want to specify 'the full number of columns for this breakpoint' and don't 
need any more context than that. Note that it is fine (and indeed expected) that hardcoded numbers
will be used in places too, especially for subsets of the columns. Use what is most readable in the
context. */

import { Breakpoint } from '.';

type FluidGridColumns = {
  [T in Breakpoint]: number;
};

const fluidGridColumns: FluidGridColumns = {
  mobile: 4,
  tabletPortrait: 8,
  tabletLandscape: 12,
  desktop: 12,
} as const;

export default fluidGridColumns;
